var transitionalDefaults = {silentJSONParsing:true,forcedJSONParsing:true,clarifyTimeoutError:false};

export { transitionalDefaults as default };
//# sourceMappingURL=transitional.js.map
